
























































































































import Vue, { PropType } from 'vue';
import Block from './Block.vue';
import Layout from './Layout.vue';
import Render from './Render.vue';
import Section from './Section.vue';
import LeftMenu from './LeftMenu.vue';
import Contacts from './Contacts.vue';
import WorkGraph from './WorkGraph.vue';
import Materials from './Materials.vue';
import DescriptionComponent from './Description.vue';
import BtnDownload from './BtnDownload.vue';
import WorkoutProject from './WorkoutProject.vue';
import SectionHeading from './SectionHeading.vue';
import AnotherVariants from './AnotherVariants.vue';
import Modal from '../Modal/Modal.vue';
import ModalLinePrimary from '../Modal/ModalLinePrimary.vue';
import ModalLineSecondary from '../Modal/ModalLineSecondary.vue';
import Input from '../Controls/Input/Input.vue';
import Button from '../Controls/Button/Button.vue';
import {
    AnotherVariant,
    Description,
    MaterialsBlock,
    MenuItem,
    PageStruct,
    RenderBlock,
} from './types';

import { authWidget } from '@/common/widgets';

export default Vue.extend({
    components: {
        Layout,
        Section,
        LeftMenu,
        Block,
        DescriptionComponent,
        BtnDownload,
        SectionHeading,
        WorkGraph,
        Render,
        WorkoutProject,
        Materials,
        Contacts,
        AnotherVariants,
        Modal,
        ModalLinePrimary,
        ModalLineSecondary,
        Input,
        Button,
    },

    props: {
        pageStruct: {
            type: Object as PropType<PageStruct>,
        },
    },

    data() {
        return {
            username: '',
            password: '',
            showModal: false,
        };
    },

    computed: {
        description(): Description {
            return this.pageStruct?.description || {};
        },

        leftMenu(): MenuItem[] {
            return this.pageStruct?.leftMenu || [];
        },

        renders(): RenderBlock[] {
            return this.pageStruct?.renders || [];
        },

        materials(): MaterialsBlock[] {
            return this.pageStruct?.materials || [];
        },

        anotherVariants(): AnotherVariant[] {
            const anotherVarLeft = this.pageStruct?.anotherVarLeft;
            const anotherVarRight = this.pageStruct?.anotherVarRight;
            return [anotherVarLeft!, anotherVarRight!].filter((i) => i);
        },

        kuulaButtonUrl(): string | null {
            return this.pageStruct?.kuulaButtonUrl || null;
        },
    },

    methods: {
        async onDownloadBtnClick(buttonWaiting: string) {
            this.$wait.start(buttonWaiting);

            const isAuthorized = await authWidget.isAuthorized();

            if (isAuthorized) {
                return authWidget.makeRedirect();
            }

            this.$wait.end(buttonWaiting);

            authWidget.show();

            authWidget.$once('authResult', ({ state }: { state: string }) => {
                if (state === 'success') {
                    authWidget.makeRedirect();
                }
            });
        },

        closeModal(): void {
            this.showModal = false;
        },
    },
});
